import { useId, useState } from 'react';
import { Drawer } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import CloseFooter from './CloseFooter';
import EntityInfoDrawer from './EntityInfoDrawer';
import MessageTranscript from './MessageTranscript';
import ProfilePicture from './ProfilePicture';
import { canOpenSpeakerProfile, displaySpeakerName } from './speakerHelper';
import './Notes.css';

export const NotesTranscriptDialog = ({ open, onClose, messageId, onChange }) => (
    <Drawer anchor='bottom' open={open} onClose={onClose} PaperProps={{ className: 'notesTranscriptPaper' }}>
        <div className='horizontalCenter appDrawerSurface notesTranscriptDialog' style={{ height: 'var(--app-height, 100svh)' }}>
            <div className='fixedDrawerHeader'>
                <div className='heading'>{onChange ? 'Select transcript' : 'Transcript'}</div>
            </div>
            <div className='hasCloseFooter hasFixedDrawerHeader'>
                {open && <MessageTranscript key={messageId} messageId={messageId} messageSelected={onChange ? (message, speaker) => {
                    onChange(message, speaker);
                    onClose();
                } : null} />}
                <CloseFooter onClick={onClose} />
            </div>
        </div>
    </Drawer>
);

const NotesTranscriptPreview = ({ messageId, messageText, speaker, onChange, onRemove, lines = 3 }) => {
    const excerptId = useId();
    const [showSpeaker, setShowSpeaker] = useState(false);
    const [showTranscript, setShowTranscript] = useState(false);
    const canOpenSpeaker = canOpenSpeakerProfile(speaker);
    const SpeakerHeader = canOpenSpeaker ? 'button' : 'div';
    return <div className='notesTranscriptPreview notesDesign'>
        {speaker && <div className='notesTranscriptHeader'>
            <SpeakerHeader className='notesSpeakerButton messagePreviewSpeakerButton' type={canOpenSpeaker ? 'button' : undefined}
                onClick={canOpenSpeaker ? () => setShowSpeaker(true) : undefined}>
                <ProfilePicture speakerId={speaker.id} borderSize={1} imageSrc={speaker.imageURL} anonymousDisplay={speaker.anonymousDisplay} size='30px' margin='0px 8px 0px 0px' />
                <span className='notesSpeakerName messagePreviewSpeakerName'>{displaySpeakerName(speaker)}</span>
            </SpeakerHeader>
            {onRemove && <button type='button' className='notesOptionsButton notesRemoveTranscript' aria-label='Remove transcript' onClick={onRemove}><CloseRounded aria-hidden='true' /></button>}
        </div>}
        <button type='button' className='notesTranscriptButton' aria-label={onChange ? 'Change transcript' : 'View transcript'} aria-describedby={excerptId} onClick={() => setShowTranscript(true)}>
            <span id={excerptId} className='notesTranscriptText' style={{ WebkitLineClamp: lines }}>{messageText}</span>
        </button>
        {canOpenSpeaker && <EntityInfoDrawer open={showSpeaker} onClose={() => setShowSpeaker(false)} speakerId={speaker.id} />}
        <NotesTranscriptDialog open={showTranscript} onClose={() => setShowTranscript(false)} messageId={messageId} onChange={onChange} />
    </div>;
};

export default NotesTranscriptPreview;
